import { IHeadCategory } from '../types/promosPage';

export const ALL_PROMOS: IHeadCategory = {
  name: 'Посмотреть все акции',
  url: '/newbuilding-promo-search/',
  queryString: '',
  iconUrl: '',
};

export const ALL_PROMOS_REDESIGNED: IHeadCategory = {
  name: 'Все акции и скидки',
  url: '/newbuilding-promo-search/',
  queryString: '',
  // TODO: Прописать адрес иконки в CD-206632.
  iconUrl: '',
};
